import {call, put, takeLatest} from 'redux-saga/effects';
import ReturnPlayersApi from '../../api/ReturnPlayersApi';
import returnPlayersActions from '../../actions/fortnite-game/returnPlayers.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getReturnPlayers(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(ReturnPlayersApi.getData, action.payload);
        yield put(
            returnPlayersActions.getReturnPlayersSuccess({
                data,
                error: data.list && data.list.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(returnPlayersActions.getReturnPlayersFailed(getErrorCodeFromResponse(e), e));
    }
}

function* returnPlayersSaga() {
    yield takeLatest(returnPlayersActions.TYPES.GET_RETURN_PLAYERS, getReturnPlayers);
}

export default returnPlayersSaga;
